import React, { useState, lazy } from 'react';
import FormInput from '../components/ui/FormInput';
import Button from '../components/ui/Button';
import { PhoneIcon, MailIcon, ClockIcon, MapPinIcon, CheckCircleIcon } from 'lucide-react';
const Contact = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    setFormSubmitted(true);
  };
  const handleNewsletterSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter signup:', newsletterEmail);
    setNewsletterEmail('');
    alert('Thank you for subscribing to our newsletter!');
  };
  return <div className="w-full bg-secondary pt-24" data-id="element-321">
      {/* Page Header */}
      <section className="bg-gradient-gold py-20 relative overflow-hidden" data-id="element-322">
        <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23D4AF37' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')"
      }} data-id="element-323"></div>
        <div className="container mx-auto px-4 text-center relative z-10" data-id="element-324">
          <h1 className="text-text-primary font-display font-black mb-4 text-4xl md:text-5xl tracking-widest" data-id="element-325">
            CONTACT US
          </h1>
          <p className="text-text-secondary max-w-2xl mx-auto font-body text-lg" data-id="element-326">
            We're here to help. Reach out to us with any questions or to
            schedule a consultation.
          </p>
        </div>
      </section>

      {/* Contact Info & Map */}
      <section className="py-16 bg-background" data-id="element-327">
        <div className="container mx-auto px-4" data-id="element-328">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-329">
            {/* Contact Information */}
            <div data-id="element-330">
              <h2 className="text-text-primary font-display font-bold mb-6 text-2xl tracking-wide" data-id="element-331">
                GET IN TOUCH
              </h2>
              <div className="space-y-6" data-id="element-332">
                <div className="flex" data-id="element-333">
                  <MapPinIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-334" />
                  <div data-id="element-335">
                    <h3 className="text-primary font-display font-semibold mb-2 text-sm tracking-wider" data-id="element-336">
                      OUR OFFICE
                    </h3>
                    <address className="not-italic text-text-secondary font-body" data-id="element-337">
                      3 Pickering St, #02-08
                      <br data-id="element-338" />
                      Singapore 048660
                      <br data-id="element-339" />
                      Singapore
                    </address>
                  </div>
                </div>
                <div className="flex" data-id="element-340">
                  <PhoneIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-341" />
                  <div data-id="element-342">
                    <h3 className="text-primary font-display font-semibold mb-2 text-sm tracking-wider" data-id="element-343">
                      PHONE
                    </h3>
                    <p className="text-text-secondary font-body" data-id="element-344">
                      <a href="tel:+6589701506" className="hover:text-primary transition-colors" data-id="element-345">
                        +65 8970 1506
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-346">
                  <MailIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-347" />
                  <div data-id="element-348">
                    <h3 className="text-primary font-display font-semibold mb-2 text-sm tracking-wider" data-id="element-349">
                      EMAIL
                    </h3>
                    <p className="text-text-secondary font-body" data-id="element-350">
                      <a href="mailto:vjayvarmmanadmin@rep.greateasternfa.sg" className="hover:text-primary transition-colors" data-id="element-351">
                        vjayvarmmanadmin@rep.greateasternfa.sg
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-352">
                  <ClockIcon size={24} className="text-primary flex-shrink-0 mr-4" data-id="element-353" />
                  <div data-id="element-354">
                    <h3 className="text-primary font-display font-semibold mb-2 text-sm tracking-wider" data-id="element-355">
                      BUSINESS HOURS
                    </h3>
                    <p className="text-text-secondary font-body" data-id="element-356">
                      Monday - Friday: By appointment only
                    </p>
                    <p className="text-text-secondary font-body" data-id="element-357">
                      Saturday & Sunday: Closed
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Map */}
            <div data-id="element-358">
              <h2 className="text-text-primary font-display font-bold mb-6 text-2xl tracking-wide" data-id="element-359">
                OUR LOCATION
              </h2>
              <div className="h-80 bg-surface rounded-lg overflow-hidden gradient-border" data-id="element-360">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8192424509883!2d103.84666907478945!3d1.2815774987147335!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da190a6f6f0001%3A0xc9e5d2013e6a4bde!2s3%20Pickering%20St%2C%20Singapore%20048660!5e0!3m2!1sen!2ssg!4v1688978654317!5m2!1sen!2ssg" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen loading="lazy" title="Magnavera Group Office Location" className="rounded-lg" data-id="element-361"></iframe>
              </div>
              <p className="text-xs text-text-secondary/60 mt-2 font-body" data-id="element-362">
                Magnavera Group is a group of representatives of Great Eastern
                Financial Advisers Pte Ltd (GEFA).
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Contact Form */}
      <section className="py-16 bg-secondary" data-id="element-363">
        <div className="container mx-auto px-4" data-id="element-364">
          <div className="max-w-2xl mx-auto" data-id="element-365">
            <h2 className="text-center text-text-primary font-display font-bold mb-8 text-3xl tracking-wide" data-id="element-366">
              SEND US A MESSAGE
            </h2>
            {formSubmitted ? <div className="text-center gradient-border p-8" data-id="element-367">
                <CheckCircleIcon size={48} className="text-primary mx-auto mb-4" data-id="element-368" />
                <h3 className="text-text-primary font-display font-bold mb-2 text-xl tracking-wide" data-id="element-369">
                  MESSAGE SENT!
                </h3>
                <p className="text-text-secondary font-body" data-id="element-370">
                  Thank you for reaching out. We'll get back to you within 24
                  hours.
                </p>
              </div> : <form onSubmit={handleSubmit} className="gradient-border p-8" data-id="element-371">
                <FormInput label="Your Name" name="name" required value={formData.name} onChange={handleChange} data-id="element-372" />
                <FormInput label="Email Address" type="email" name="email" required value={formData.email} onChange={handleChange} data-id="element-373" />
                <FormInput label="Message" type="textarea" name="message" required placeholder="How can we help you?" value={formData.message} onChange={handleChange} data-id="element-374" />
                <div className="mt-6" data-id="element-375">
                  <Button type="submit" data-id="element-376">SEND MESSAGE</Button>
                </div>
              </form>}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-16 bg-gradient-gold" data-id="element-377">
        <div className="container mx-auto px-4 text-center" data-id="element-378">
          <h2 className="text-text-primary font-display font-bold mb-4 text-3xl tracking-wide" data-id="element-379">
            STAY UPDATED
          </h2>
          <p className="text-text-secondary max-w-2xl mx-auto mb-8 font-body text-lg" data-id="element-380">
            Subscribe to our newsletter for financial tips, industry updates,
            and special event invitations.
          </p>
          <form onSubmit={handleNewsletterSubmit} className="max-w-md mx-auto flex flex-col sm:flex-row gap-4" data-id="element-381">
            <input type="email" placeholder="Your email address" className="flex-grow px-4 py-3 rounded bg-surface text-text-primary border border-border focus:outline-none focus:border-primary font-body" value={newsletterEmail} onChange={e => setNewsletterEmail(e.target.value)} required data-id="element-382" />
            <Button type="submit" className="bg-secondary text-primary hover:bg-surface" data-id="element-383">
              SUBSCRIBE
            </Button>
          </form>
        </div>
      </section>
    </div>;
};
export default Contact;